module.exports = __webpack_public_path__ + "static/media/feature_4_3.cb24e0a9.jpg";